import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { NitroMarkerBase } from "../map/components/NitroMarker";

const OccupantTypeFilter = ({
  type,
  setType,
}: {
  type: "Competitor" | "Koch" | "Customer";
  setType: (value: "Competitor" | "Koch" | "Customer") => void;
}) => {
  return (
    <Select
      id="occupant-type-filter-select"
      value={type}
      onChange={(e) => {
        setType(e.target.value as any);
      }}
      size="small"
      MenuProps={{ sx: { zIndex: 10200 } }}
      renderValue={(value: string) => (
        <div
          id="occupantTypeFilterValue"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <NitroMarkerBase type={value.toLowerCase()} width={24} />
          {value}
        </div>
      )}
    >
      <MenuItem
        value="Competitor"
        style={{
          display: "flex",
          gap: 4,
          fontSize: 14,
          height: 35,
        }}
      >
        <NitroMarkerBase type="competitor" width={24} />
        Competitor
      </MenuItem>
      <MenuItem
        value="Customer"
        style={{
          display: "flex",
          gap: 4,
          fontSize: 14,
          height: 35,
        }}
      >
        <NitroMarkerBase type="customer" width={24} />
        Customer
      </MenuItem>
      <MenuItem
        value="Koch"
        style={{
          display: "flex",
          gap: 4,
          fontSize: 14,
          height: 35,
        }}
      >
        <NitroMarkerBase type="koch" width={24} />
        Koch
      </MenuItem>
    </Select>
  );
};

export default OccupantTypeFilter;
